import type { Router } from 'vue-router';

import { bootstrapGtag, gtag, isGtagReady } from './gtag';

// Public analytics surface for route pageviews and UI events. Every event
// carries event_category='celerdata_byoc' so downstream GA4 reports group
// product events together.

export const EVENT_CATEGORY = 'celerdata_byoc';

export interface AnalyticsEventParams {
  event_label?: string;
  event_innertext?: string;
  [key: string]: unknown;
}

export function trackEvent(action: string, params: AnalyticsEventParams = {}): void {
  if (!action || !isGtagReady()) return;
  gtag('event', action, { event_category: EVENT_CATEGORY, ...params });
}

export function trackPageView(path: string, title?: string): void {
  if (!path || !isGtagReady()) return;
  gtag('event', 'page_view', {
    page_path: path,
    page_title: title ?? document.title,
    page_location: window.location.href,
  });
}

export function initAnalytics(router: Router): void {
  const primary = import.meta.env.VITE_GTAG;
  const secondary = import.meta.env.VITE_GTAG_WEB;
  if (!primary) return;
  bootstrapGtag(primary, secondary || undefined);
  router.afterEach((to) => {
    trackPageView(to.fullPath, document.title);
  });
}
